import React from 'react';
import { useNavigate } from 'react-router-dom';
import FeaturedSolutions, { AgilysysLogo } from '../components/FeaturedSolutions';

const A = '/assets/casino/solutions/';

const solutions = [
  { name: 'IG Fly',       path: 'ig-fly',       screenshot: A + 'fly-tap-pay.png' },
  { name: 'IG OnDemand',  path: 'ig-on-demand', screenshot: A + 'app-ondemand-food.png' },
  { name: 'IG Quick Pay', path: 'ig-quick-pay', screenshot: A + 'app-qr-quickpay.png' },
  { name: 'Reserve',      path: 'reserve',      screenshot: A + 'app-reserve2.png' },
  { name: 'Guest App',    path: 'guest-app',    screenshot: A + 'app-guest-dining.png' },
];

function Beach() {
  const navigate = useNavigate();
  return (
    <div className="page beachPage">
      <div className="page-header">Beach Front</div>
      <div className="text-blocks">
        <div className="std-text">Delight guests with food and beverage at-a-click ordering delivered wherever they are. Enhance the beach and cabana experience with fast, easy, mobile ordering and payment to drive increased order volume, improve check size and grow F&B revenue.{"\n\n"}</div>
        <div className="std-text">And ensure guests can enjoy their preferred beach chair or cabana with online reservations that keep them in the sun and relaxing.</div>
      </div>
      <FeaturedSolutions>
        {solutions.map((sol) => (
          <div key={sol.path} className="featured-item" onClick={() => navigate(`/solutions/${sol.path}`)}>
            <div className="item-head"><AgilysysLogo />{sol.name}</div>
            <img src={sol.screenshot} alt={sol.name} />
          </div>
        ))}
      </FeaturedSolutions>
    </div>
  );
}

export default Beach;
